import { breakpoints, ThemeDefinition, theme } from "@shapeable/theme";
import { css } from "styled-components";

export const YELLOW = '#FFCA04';
export const YELLOW_DARK = '#FCB10F';
export const YELLOW_ORANGE = '#F79616';
export const AQUA_BLUE = '#1BB1AB';
export const GESDA_PURPLE = '#623B70';
export const GESDA_PURPLE_DARK = '#420866';
export const GESDA_GREEN = '#44C4A0';
export const GESDA_PURPLE_LIGHT = '#7017BB';

export const CHART_BG = '#F7F2FD';

export const BRIGHT_WARM = '#F7F2FD';

export const BRIGHT_MENU_BAR_OVERLAY = `#FFFFFFFA`;

export const themeOverrides: ThemeDefinition = {
  light: {
    color: {
      primary: "#1BB1AB",
      link: AQUA_BLUE,
      brightWarm: BRIGHT_WARM,
      buttonHover: BRIGHT_WARM,
      primaryLight: GESDA_GREEN,
      linkHover: '#159994',
    },
  },
  font: {
    family: {
      serif: 'Aleo',
      sans: 'Montserrat',
      heading: 'Aleo',
      copy: 'Montserrat',
    }
  },
};


/* 
--------------------

  Layout Styles
  
  NB: This is the appropriate place to override styling for this specific site, based on BEM-style class name targets 
  
--------------------
*/

export const LayoutStyles = breakpoints({
  base: css`
    font-size: ${theme.FONT_SIZE(14)};

    .shp--site-header-utility-button__disclosure-icon {
      opacity: 0.3;
    }

    /* New Gesda nav update requires thinner desktop header - padding must be removed to prevent content from being pushed down */
    .shp--site-header-layout__navigation-and-controls {
      padding: 0;
    }

    .shp--grid-back-button__icon {
      display: none;
    }

    
    .shp--site-menu-bar {
      backdrop-filter: blur(1px);
      ${theme.HOVER_SHADOW()};
      border-bottom: 1px solid ${theme.COLOR('line-very-subtle')};
      h1 {
        font-size: 15px;
      }
    }

    .shp--outline-entity-dot-link {
      a { 
        .shp--dot {
          ${theme.TRANSITION('scale')}
        }
        &:hover {
          .shp--dot {
            scale: 0.9;
          }
        }
      }
    }


    .shp--organisation-powered-by {
      opacity: 0.6;

      img {
        mix-blend-mode: overlay;
        filter: grayscale(1);
      }

      &:hover {
        filter: none;
      }
    }

    .shp--video-image {
      width: 100%;
      max-width: 800px;
    }

    .shp--content {

      img {
        max-width: 100%;
      }

      ol li,
      ul li {
        font-weight: 300;
        color: ${theme.COLOR('strong')};
      }
    }

    .mapboxgl-marker .gatsby-image-wrapper.gatsby-image-wrapper-constrained {
      display: block;
      img {
        object-fit: cover !important;
        padding: 0 !important;

      }
    }

    .shp--markdown-embed .gatsby-image-wrapper.gatsby-image-wrapper-constrained {
      img {
        object-fit: cover !important;
        height: auto !important;
      }
    }
    
    .gatsby-image-wrapper [data-placeholder-image] {
      transition: none !important;
      opacity: 0 !important;
    }

    .gatsby-image-wrapper [data-main-image] {
      transition: none !important;
      opacity: 1 !important;
    }

    .shp--slice-intro {
      font-size: 1.75em;
      text-align: left;
      line-height: 1.25em;
    }

    .shp--slice-section-color-block {
      max-height: 600px;
    }

    .shp--person-bio-cell {
      img,
      .gatsby-image-wrapper img {
        object-fit: cover !important;
      }
    }

  `,
  tablet: css`
    font-size: ${theme.FONT_SIZE(15)};
  
    .shp--slice-intro {
      font-size: 2em;
      text-align: left;
      line-height: 1.25em;
    }
  `,
  desktop: css`
    font-size: ${theme.FONT_SIZE(16)};
    .shp--content {
      img {
        max-width: 100%;
      }
    }

  `,
});